import { themedUseStyletron } from '../../../theme/customTheme'
import { IFlapTwoPoint } from './types'
import { StatefulOperationModeSelect } from '../Aggregate';
import { OperatorPanelWrapper } from '../../components/Layout'
import { MdAmpStories } from "react-icons/md";
import { AggregateOpenCloseText } from '../Aggregate';

export const OperatorPanel = (props: IFlapTwoPoint) => {
    const [, theme] = themedUseStyletron();

    return (
        <OperatorPanelWrapper
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    <MdAmpStories color={props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='40px' />
                    <AggregateOpenCloseText {...props}></AggregateOpenCloseText>
                </>
            }
            operationModeContent={<StatefulOperationModeSelect {...props}></StatefulOperationModeSelect>}>
        </OperatorPanelWrapper>
    )
} 